import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';

export interface ScreenshotDialogData {
  imageUrl: string;
  imageBlob: Blob;
}

@Component({
  selector: 'app-screenshot-preview',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './screenshot-preview.html',
  styleUrl: './screenshot-preview.scss'
})
export class ScreenshotPreview {
  constructor(
    public dialogRef: MatDialogRef<ScreenshotPreview>,
    @Inject(MAT_DIALOG_DATA) public data: ScreenshotDialogData,
    private _snackBar: MatSnackBar
  ) {}

  async copyToClipboard() {
    try {
      // Create a ClipboardItem with the image blob
      const clipboardItem = new ClipboardItem({
        [this.data.imageBlob.type]: this.data.imageBlob
      });

      await navigator.clipboard.write([clipboardItem]);
      this._snackBar.open('Screenshot copied to clipboard!', 'Close', { duration: 3000 });
    } catch (error) {
      console.error('Failed to copy image to clipboard:', error);
      this._snackBar.open('Failed to copy screenshot to clipboard', 'Close', { duration: 3000 });
    }
  }

  close() {
    this.dialogRef.close();
  }
}
